module.exports = __webpack_public_path__ + "img/mono_24.b9ff7caf.png";